import { Heading } from '../../ui';

interface CamhsConsentFinishProps {
    childName: string;
}

export function CamhsConsentFinish({ childName }: CamhsConsentFinishProps) {
    return (
        <div className="max-w-[684px] mx-auto my-20 space-y-6 text-center">
            <Heading level={1}>Thank you</Heading>
            <p>Thank you for giving your consent, we'll now begin pairing {childName} with a therapist. </p>
            <p>We are setting up your guardian account and will be in touch when we have found a therapist match.</p>
        </div>
    );
}
